{
  "loadMap": "Load map",
  "lowDataNote": "Low-data mode is on, so the map loads only when you ask.",
  "unavailable": "The map can't be shown on this device. Use the list below.",
  "usingOffline": "Offline map",
  "usingFallback": "Backup map",
  "tapToPlace": "Tap the map to place the pin, or use your location.",
  "locateFailed": "We couldn't get your location. Drag the pin or tap the map instead."
}
